module.exports = __webpack_public_path__ + "img/A58A2798.a7a1ffa8.jpg";